import { Injectable } from '@angular/core';
import { RegisterRequestModel } from '@picard/models-lib';

@Injectable({
  providedIn: 'root'
})
export class RegistrationService {
  registerRequestModel: RegisterRequestModel;
  constructor() {
    this.registerRequestModel = new RegisterRequestModel();
  }

}
